/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'project-content.project-content-about.the-measure-placeholder':
    'Describe what success looks like and what you hope to achieve.',
  'project-content.project-content-about.the-measure-title': "How we'll know we're successful",
  'project-content.project-content-about.the-what-placeholder': 'Describe this project and the work it entails.',
  'project-content.project-content-about.the-what-title': "What we're doing",
  'project-content.project-content-about.the-why-placeholder':
    'Explain why this work is happening and the reasons that are driving it.',
  'project-content.project-content-about.the-why-title': "Why we're doing it",
  'project-content.project-content-updates.add-update': 'Add update',
  'project-content.project-content-updates.archived': 'Archived',
  'project-content.project-content-updates.at-risk': 'At risk',
  'project-content.project-content-updates.cancelled': 'Canceled',
  'project-content.project-content-updates.completed': 'Completed 🎉',
  'project-content.project-content-updates.date-changed': 'Date changed',
  'project-content.project-content-updates.edit-update': 'Edit',
  "project-content.project-content-updates.for-date'": 'for {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Latest update',
  'project-content.project-content-updates.missed-update-message': 'No update was posted',
  'project-content.project-content-updates.new-due-date': 'New due date',
  'project-content.project-content-updates.new-state': 'New state',
  'project-content.project-content-updates.no-updates-description': 'There are no updates for this project yet.',
  'project-content.project-content-updates.off-track': 'Off track',
  'project-content.project-content-updates.old-due-date': 'Old due date',
  'project-content.project-content-updates.old-state': 'Old state',
  'project-content.project-content-updates.on-track': 'On track',
  'project-content.project-content-updates.paused': 'Paused',
  'project-content.project-content-updates.pending': 'Pending',
  'project-content.project-content-updates.previous-updates-title': 'Previous updates',
  'project-content.project-content-updates.share-update': 'Share',
  'project-content.project-content-updates.status-changed': 'Status changed',
  'project-content.project-content-updates.write-update-button': 'Write an update',
};
